import { useEffect, useState } from "react";
import { http, fmtErr } from "@/lib/api";
import { toast } from "sonner";

export default function NotificationSettings() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => { http.get("/admin/settings/notifications").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  if (!cfg) return null;

  const save = async (patch) => {
    try {
      const r = await http.put("/admin/settings/notifications", { ...cfg, ...patch });
      setCfg(r.data);
      toast.success("Notification settings saved");
    } catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div className="card" data-testid="notification-settings">
      <h3 className="font-serif text-2xl mb-1">Notification Email</h3>
      <p className="text-xs mb-3" style={{ color: "var(--muted)" }}>
        Where operational notifications would be sent. Email delivery is <b>not connected</b> yet — this only stores the address for when an email provider is added.
      </p>
      <label className="flex items-center gap-3 mb-4 text-sm cursor-pointer">
        <input type="checkbox" style={{ width: "auto" }} data-testid="notif-same" checked={!!cfg.same_as_contact}
          onChange={(e) => save({ same_as_contact: e.target.checked })} />
        Same as Property Contact Email
      </label>
      {!cfg.same_as_contact && (
        <>
          <label className="text-xs block mb-1" style={{ color: "var(--muted)" }}>Notification email</label>
          <input data-testid="notif-email" type="email" value={cfg.notification_email || ""} className="mb-3"
            onChange={(e) => setCfg({ ...cfg, notification_email: e.target.value })} onBlur={() => save({})} />
        </>
      )}
      <span className="badge-terracotta">EMAIL PROVIDER NOT CONNECTED</span>
    </div>
  );
}
